import React from "react";
import { colors } from "../../../../../shared/constants";
import * as Icons from "../../../../Icons";
import { concatUrl } from "../../../helpers";
import MenuBadge from "../MenuBadge";
import * as S from "../styles";

var SubMenu = function SubMenu(_ref) {
  var e = _ref.categoryInfo,
      t = _ref.handleSubLinkClick,
      r = _ref.renderLinkAs,
      a = _ref.handleFilteredPipLinkClick,
      n = _ref.root,
      l = _ref.hasPartialPipLoad;

  var _ref2 = e || {},
      c = _ref2.productLinks,
      o = _ref2.filteredPipLink,
      u = _ref2.card;

  if (!c) return null;

  var i = function i(e) {
    return e.map(function (e, a) {
      return React.createElement(S.ProductLink, {
        key: "".concat(e.slug, "-").concat(a),
        href: concatUrl(e.url, n),
        onClick: function onClick() {
          return t(e.tags[0], e.label);
        },
        as: r || void 0
      }, e.label, e.badge ? React.createElement(MenuBadge, {
        text: e.badge,
        backgroundColor: colors.teal4
      }) : null);
    });
  };

  return React.createElement(React.Fragment, null, React.createElement(S.SubMenuSectionWrapper, {
    key: "links"
  }, Array.isArray(c) ? i(c) : Object.keys(c).map(function (e) {
    return React.createElement(S.SubMenuSubCategoryWrapper, {
      key: e
    }, React.createElement(S.SubHeaderContainer, null, React.createElement(S.SubMenuSubHeader, null, e)), i(c[e]));
  }), o ? React.createElement(S.ExitMenuLink, {
    href: concatUrl(o.url, n),
    onClick: function onClick() {
      return a(o);
    },
    as: r && l ? r : void 0
  }, "Shop all ".concat(o.categoryName), r && l ? React.createElement(Icons.RightArrow, null) : void 0) : null), React.createElement(S.SubMenuSectionWrapper, {
    key: "cards"
  }, React.createElement(S.ProductCard, Object.assign({
    key: null == u ? void 0 : u.slug
  }, u))));
};

export default SubMenu;